import { endpoints } from '../../Constants';
// eslint-disable-next-line object-curly-newline
import { authHeader, toQueryStringURL } from '../../Helpers';
import handleResponse from '../helpers';

const customizationServices = {
	gateway,
};

function gateway({ req, method }) {
	switch (method) {
		case 'VIEW':
			return viewCustomization({
				req,
			});
		case 'LIST':
			return listCustomizations({
				req,
			});
		case 'UPDATE':
			return updateCustomization({
				req,
			});
		case 'PATCH':
			return patchCustomization({
				req,
			});
		default:
			break;
	}
	return new Promise();
}

function patchCustomization({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.UPDATE_RECIPE_FLAGS, params);

	const requestOptions = {
		method: 'PATCH',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function updateCustomization({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.SAVE_CUSTOMIZATION, params);

	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req.data,
		}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function viewCustomization({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.VIEW_RECIPE, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function listCustomizations({ req }) {
	const params = {
		...req.params,
	};

	const url = toQueryStringURL(endpoints.LIST_RECIPES, params);

	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(url, requestOptions).then(handleResponse);
}

export default customizationServices;
